module.exports = __webpack_public_path__ + "static/media/Cramelpop_preview.98756b04.jpg";